import { render, staticRenderFns } from "./DocumentsCompanyPanel.vue?vue&type=template&id=46191dab&scoped=true"
import script from "./DocumentsCompanyPanel.vue?vue&type=script&lang=js"
export * from "./DocumentsCompanyPanel.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCompanyPanel.vue?vue&type=style&index=0&id=46191dab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46191dab",
  null
  
)

export default component.exports